import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { UtilService } from '../../../services/util.service';

@Component({
    selector: 'itpx-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: [ './progress-bar.component.css' ]
})

export class ProgressBarComponent implements OnInit, OnDestroy {

    private isInProgress: boolean = false;
    private sub: Subscription;

    constructor(private utilService: UtilService) { }

    ngOnInit() {
        this.sub = this.utilService.isInProgress$.subscribe(
            (data: any) => {
                this.isInProgress = data;
            },
            (error: any) => {
                console.log(error);
            }
        );
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}


// WEBPACK FOOTER //
// ./src/app/core/components/partials/progress-bar/progress-bar.component.ts